<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <office-select-search
          :shadow="false"
          :request-params="{ 'filter[office_category_id]': 4 }"
          v-model="filter.office"
          @change="onFilter"
        />
        <base-input
          v-if="filter.office?.attributes?.office_id"
          type="text"
          placeholder="Cari No Faktur"
          :shadow="false"
          debounce
          v-model="filter.search_order_code"
          @native-input="onFilter"
        />
        <period-select v-model="filter.period_id" @change="onFilter" />
      </div>
      <alert
        v-if="!filter.office.attributes?.office_id || !filter.period_id"
        type="warning"
        message="Stockist belum dipilih"
      />
      <template v-else>
        <datatable
          :columns="tableColumns"
          :total="balanceTransactions.meta.page.total"
          :perPage="balanceTransactions.meta.page.perPage"
          :currentPage="balanceTransactions.meta.page.currentPage"
          @pagechanged="onPageChanged"
        >
          <template #tbody="{ classes }">
            <template
              v-for="(balanceTransaction, index) in balanceTransactions.data"
            >
              <tr
                :key="balanceTransaction.attributes.id"
                :class="[classes.tr, 'bg-white']"
              >
                <td :class="classes.td">
                  {{
                    balanceTransaction.attributes.createdAt
                      | formatDate
                  }}
                </td>
                <td :class="classes.td">
                  <a href="#" class="cursor-pointer hover:underline">{{ balanceTransaction.attributes.order_code }}</a>
                </td>

                <td :class="classes.td">
                  <a href="#" class="cursor-pointer hover:underline">{{ balanceTransaction.attributes.payment_code }}</a>
                </td>
                <td :class="classes.td">
                  {{ balanceTransaction.attributes.description }}
                </td>
                <td :class="[classes.td, 'text-right']">
                  <p v-if="balanceTransaction.attributes.order_price">
                    -{{
                      balanceTransaction.attributes.order_price | toCurrency
                    }}
                  </p>
                </td>
                <td :class="[classes.td, 'text-right']">
                  <p v-if="balanceTransaction.attributes.payment_amount">
                    +{{
                      balanceTransaction.attributes.payment_amount | toCurrency
                    }}
                  </p>
                </td>
                <td :class="[classes.td, 'text-right']">
                  {{ balanceTransaction.attributes.balance | toCurrency }}
                </td>
                <td :class="[classes.td, 'text-right']">
                  {{ balanceTransaction.attributes.debt | toCurrency }}
                </td>
                <td :class="classes.td">
                  <div
                    v-if="
                      balanceTransaction.attributes.type === 'order' ||
                      balanceTransaction.attributes.type === 'payment'
                    "
                    class="flex justify-end"
                  >
                    <button @click="onToggleDetail(index, balanceTransaction)">
                      <Icon
                        :icon="
                          visiblePaymentDetails.includes(index)
                            ? 'heroicons:chevron-down'
                            : 'heroicons:chevron-right'
                        "
                        class="h-4 w-4"
                      />
                    </button>
                  </div>
                </td>
              </tr>
              <template v-if="visiblePaymentDetails.includes(index)">
                <tr
                  v-for="balanceTransactionItem in balanceTransactionItems[
                    balanceTransaction.id
                  ]"
                  :key="`${balanceTransaction.id}-${balanceTransactionItem.id}`"
                  :class="[classes.tr, 'bg-gray-50']"
                >
                  <td colspan="3"></td>
                  <td :class="classes.td">
                    {{ balanceTransactionItem.attributes.name }}
                  </td>
                  <td></td>
                  <td :class="[classes.td, 'text-right']">
                    {{ balanceTransactionItem.attributes.amount | toCurrency }}
                  </td>
                </tr>
              </template>
            </template>
            <tr :class="[classes.tr, 'bg-white']">
              <td colspan="3"></td>
              <td :class="classes.td">Total</td>
              <td :class="[classes.td, 'text-right']">
                {{ summary.total_order_price | toCurrency }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  summary.total_payment_amount | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ summary.balance | toCurrency }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ summary.debt | toCurrency }}
              </td>
              <td colspan="3"></td>
            </tr>
          </template>
        </datatable>
      </template>
    </div>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import Alert from '@/components/base/AlertMessage.vue';
import OfficeSelectSearch from '@/components/office/office-select-search.vue';
import PeriodSelect from '@/components/period/period-select.vue';

export default {
  mixins: [requestMixin],
  components: {
    Alert,
    OfficeSelectSearch,
    PeriodSelect,
  },
  data() {
    return {
      visiblePaymentDetails: [],
      currentPeriod: {
        data: {
          attributes: {},
        },
      },
      filter: {
        office: {
          attributes: {
            office_id: null,
          },
        },
        period_id: null,
        search_order_code: null,
      },
      loadingCurentPeriod: false,
      loadingBalanceTransaction: false,
      loadingBalanceTransactionItems: false,
      loadingSummary: false,
      balanceTransactions: {
        data: [],
        meta: {
          page: {
            total: 0,
          },
        },
      },
      balanceTransactionItems: {},
      summary: {
        total_order_price: 0,
        total_payment_amount: 0,
        balance: 0,
        debt: 0,
      }
    };
  },
  computed: {
    loading() {
      return (
        this.loadingCurentPeriod ||
        this.loadingBalanceTransaction ||
        this.loadingBalanceTransactionItems ||
        this.loadingSummary
      );
    },
    tableColumns() {
      return [
        {
          id: 'createdAt',
          name: 'Tanggal',
        },
        {
          id: 'order_code',
          name: 'No Faktur',
        },
        {
          id: 'payment_code',
          name: 'No Invoice',
        },
        {
          id: 'description',
          name: 'Keterangan',
        },
        {
          id: 'final_price',
          name: 'Belanja',
          theadClass: 'text-right',
        },
        {
          id: 'payment_amount',
          name: 'Pembayaran',
          theadClass: 'text-right',
        },
        {
          id: 'balance',
          name: 'Saldo',
          theadClass: 'text-right',
        },
        {
          id: 'debt',
          name: 'Kurang Bayar',
          theadClass: 'text-right',
        },
        {
          id: 'collapse',
          name: '',
        },
      ];
    },
  },
  methods: {
    async loadCurrentPeriod() {
      this.loadingCurentPeriod = true;

      const [res, err] = await this.request(
        '/api/v1/periods/-actions/get-current-period'
      );

      if (!err) {
        this.currentPeriod = res;

        this.filter.period_id = res.data.id;
      }

      this.loadingCurentPeriod = false;
    },
    async loadBalanceTransactions(params) {
      this.loadingBalanceTransaction = true;

      this.visiblePaymentDetails = [];
      this.balanceTransactionItems = {};

      const [res, err] = await this.request(
        `/api/v1/offices/${this.filter.office.attributes?.office_id}/office-balance-transactions`,
        {
          params: {
            'filter[period_uuid]': this.filter.period_id,
            'filter[search_order_code]': this.filter.search_order_code || null,
            sort: '-id',
            'page[size]': 10,
            ...params,
          },
        }
      );

      if (!err) {
        this.balanceTransactions = res;

        this.balanceTransactionItems = Object.fromEntries(
          res.data.map((item) => [item.id, []])
        );
      }

      this.loadingBalanceTransaction = false;
    },
    async loadBalanceTransactionItems(balanceTransactionId) {
      this.loadingBalanceTransactionItems = true;

      const [res, err] = await this.request(
        `/api/v1/office-balance-transactions/${balanceTransactionId}/items`
      );

      if (!err) {
        this.balanceTransactionItems[balanceTransactionId] = res.data;
      }

      this.loadingBalanceTransactionItems = false;
    },
    async loadSummary() {
      this.loadingSummary = true;

      const [res, err] = await this.request(
        `/api/v1/office-balance-summaries`,
        {
          params: {
            'filter[office_uuid]': this.filter.office.attributes?.office_id,
            'filter[period_uuid]': this.filter.period_id,
            'filter[balance_type]': 'stockist_balance'
          }
        }
      );

      if (!err) {
        if (res.data.length) {
          const [summary] = res.data

          this.summary.total_order_price = summary.attributes.total_order_price
          this.summary.total_payment_amount = summary.attributes.total_payment_amount
          this.summary.balance = summary.attributes.balance
          this.summary.debt = summary.attributes.debt
        } else {

          this.summary.total_order_price = 0
          this.summary.total_payment_amount = 0
          this.summary.balance = 0
          this.summary.debt = 0
        }
      }

      this.loadingSummary = false;
    },
    onFilter() {
      this.loadBalanceTransactions();
      this.loadSummary()
    },
    onPageChanged(page) {
      this.loadBalanceTransactions({
        'page[number]': page,
      });
    },
    onToggleDetail(index, balanceTransaction) {
      if (this.visiblePaymentDetails.includes(index)) {
        this.visiblePaymentDetails.splice(
          this.visiblePaymentDetails.indexOf(index),
          1
        );
      } else {
        this.visiblePaymentDetails.push(index);

        if (!this.balanceTransactionItems[balanceTransaction.id].length) {
          this.loadBalanceTransactionItems(balanceTransaction.id);
        }
      }
    },
  },
  async created() {
    await this.loadCurrentPeriod();
  },
};
</script>
